import type { SxProps, Theme } from '@mui/material/styles';

type SettingListsItemsStyleMap = {
    root: SxProps<Theme>
    paper: SxProps<Theme>
    tabsHeader: SxProps<Theme>
    tab: SxProps<Theme>
    addButton: SxProps<Theme>
    loadingContainer: SxProps<Theme>
    tableHeaderRow: SxProps<Theme>
    tableHeaderCell: SxProps<Theme>
    newRow: SxProps<Theme>
};

export const settingListsItemsStyles: SettingListsItemsStyleMap = {
    root: { display: 'flex', flexDirection: 'column', gap: 3 },
    paper: { border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' },
    tabsHeader: { borderBottom: '1px solid', borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2 },
    tab: { textTransform: 'none' },
    addButton: { my: 1 },
    loadingContainer: { display: 'flex', justifyContent: 'center', py: 6 },
    tableHeaderRow: { bgcolor: 'grey.50' },
    tableHeaderCell: { fontWeight: 600 },
    newRow: { bgcolor: 'primary.50' },
};

export const getSettingListEditingRowStyles = (isEditing: boolean): SxProps<Theme> => ({
    bgcolor: isEditing ? 'primary.50' : undefined,
});
